/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import Immutable from 'immutable';
import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';
import { Column } from 'edrolo-style-guide';
import Checklist from './Checklist';
import styles from './style.scss';

class LinkedChecklist extends Component {
  state = {
    highlightedSerial: null,
  };

  setHighlightedSerial = (serial, value) => {
    if (value === true) {
      this.setState({
        highlightedSerial: serial,
      });
    }
    if (value === false && this.state.highlightedSerial === serial) {
      this.setState({
        highlightedSerial: null,
      });
    }
  };

  render() {
    const {
      checklistItems,
      checklistReflections,
      onChecklistReflection,
      renderLinkedComponent,
      isSaving,
    } = this.props;

    return (
      <div className={styles.reflectionContainer}>
        <Column size={12}>
          <div className={styles.checklistHeading}>Checklist</div>
          {isSaving && (
            <span className={styles.savingIndicator}>Saving...</span>
          )}
        </Column>

        <Column size={8}>
          <Checklist
            items={checklistItems}
            onChange={(itemId, value, currentValue) =>
              onChecklistReflection(itemId, value, currentValue)
            }
            reflectionMap={Immutable.Map(
              checklistReflections.map((reflection) => [
                `${reflection.get('exemplar_response_checklist_item')}`,
                reflection.get('checked'),
              ])
            )}
            onHighlightSerial={(serial, value) =>
              this.setHighlightedSerial(serial, value)
            }
            highlightedSerial={Number(this.state.highlightedSerial)}
          />
        </Column>
        <Column size={4}>
          {renderLinkedComponent(
            this.state.highlightedSerial,
            (serial, value) => this.setHighlightedSerial(serial, value)
          )}
        </Column>
      </div>
    );
  }
}

LinkedChecklist.propTypes = {
  checklistItems: IPT.listOf(
    IPT.contains({
      description: PT.string.required,
      is_hyperlinked: PT.bool,
      serial: PT.number,
      id: PT.number,
    })
  ),
  checklistReflections: IPT.listOf(
    IPT.contains({
      response: PT.number,
      exemplar_response_checklist_item: PT.number,
      checked: PT.bool,
    })
  ),
  onChecklistReflection: PT.func, // (itemId, value) => null record a reflection
  renderLinkedComponent: PT.func,
};

LinkedChecklist.defaultProps = {
  renderLinkedComponent: (highlightedSerial) => <p>{highlightedSerial}</p>,
};

export default LinkedChecklist;
